import React from 'react';
import CopyableId from './CopyableId';

interface ContractAddressProps {
  address: string;
  className?: string;
}

const ContractAddress: React.FC<ContractAddressProps> = ({ address, className }) => (
  <CopyableId value={address} label="Contract address" className={className} />
);

export default ContractAddress;
